// @flow

import type {DigitalProductType} from './types'

export const isUserAllowedToWatch = (digitalProducts: Array<DigitalProductType>) =>
  // If there are no digital products then the content is free
  digitalProducts.length === 0 ||
  // Otherwise check there are one or more digital products where has_purchased is true
  digitalProducts.filter(digitalProduct => digitalProduct.has_purchased).length > 0
